/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: AlphabeticallistofproductsRoutingModule
 * Purpose		: Routing module for Alphabeticallistofproducts.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AlphabeticallistofproductsListComponent } from './AlphabeticallistofproductsList.component';
import { AlphabeticallistofproductsDetailsComponent } from './AlphabeticallistofproductsDetails.component';

const AlphabeticallistofproductsRoutes: Routes = [
	{ path: 'Alphabeticallistofproducts',  component: AlphabeticallistofproductsListComponent },
	{ path: 'Alphabeticallistofproducts/Details/:id', component: AlphabeticallistofproductsDetailsComponent },
];

@NgModule({
  imports: [
    RouterModule.forChild(AlphabeticallistofproductsRoutes)
  ],
  exports: [
    RouterModule
  ]
})

export class AlphabeticallistofproductsRoutingModule { }



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/Alphabeticallistofproducts/Alphabeticallistofproducts-routing.module.ts